// Generated by scripts/pull-catalogue.ts from D1 — do not edit by hand.
//
// This is the catalogue as of the last pull: the offline fallback the storefront
// renders when /api/bootstrap is unreachable. Regenerate with `npm run db:pull`.
import type { Product } from '../types'

const spec = (
  labelSq: string,
  labelEn: string,
  valueSq: string,
  valueEn: string,
) => ({ label: { sq: labelSq, en: labelEn }, value: { sq: valueSq, en: valueEn } })

export let PRODUCTS: Product[] = [
  {
    id: 1,
    slug: "ms-clear-coat",
    sku: "BF8400",
    name: { sq: "RIFINID Llak MS", en: "RIFINID MS Clear Coat" },
    category: "llaqe",
    brand: "RIFINID",
    variants: [
      { id: 26, label: { sq: "1 L + 0.5L", en: "1 L + 0.5L" }, option: { sq: "I shpejte", en: "Fast" }, packQty: 12 },
      { id: 52, label: { sq: "1 L + 0.5L", en: "1 L + 0.5L" }, option: { sq: "Standart", en: "Standard" }, packQty: 12 },
    ],
    optionName: { sq: "Katalit", en: "Hardner" },
    tag: "",
    short: { sq: "Llak MS profesional me katalizator për rifiniturë automobilistike, me shkëlqim të lartë, aplikim të lehtë dhe rezistencë të mirë ndaj konsumimit dhe kimikateve.", en: "Professional MS clear coat with hardener for automotive refinishing, offering high gloss, easy application and good resistance to abrasion and chemicals." },
    description: {
      sq: "Llak transparent MS me bazë poliuretani akrilik për rifiniturën profesionale të automjeteve. Ofron shkëlqim të lartë, rezistencë të mirë ndaj gërryerjes dhe agjentëve kimikë, si dhe lustrohet lehtë pas tharjes. I përshtatshëm për riparime të përgjithshme dhe aplikime të përditshme në karroceri.\nPërdoret me katalizator BF7600A Standard ose BF7600C Fast, sipas temperaturës dhe kushteve të punës.\nKODI: BF8400",
      en: "MS acrylic polyurethane clear coat for professional automotive refinishing. Provides high gloss, good resistance to abrasion and chemicals, and easy polishing after curing. Suitable for general repairs and everyday body shop applications.\nUsed with BF7600A Standard or BF7600C Fast Hardener, depending on temperature and application conditions. CODE: BF8400.",
    },
    specs: [

    ],
    image: "1-cb3dfdf6",
    datasheet: "1-1e984bf0",
  },
  {
    id: 2,
    slug: "matte-clear-coat-rifinid",
    sku: "BF8600Q",
    name: { sq: "RIFINID Llak Mat", en: "RIFINID Matte Clear Coat" },
    category: "llaqe",
    brand: "RIFINID",
    variants: [
      { id: 27, label: { sq: "1 L + 0.5L", en: "1 L + 0.5L" }, option: { sq: "Standart", en: "Standard" }, packQty: 12 },
    ],
    optionName: { sq: "Katalit", en: "Hardner" },
    tag: "",
    short: { sq: "Llak mat profesional me finish uniform soft-matte, i kompletuar me katalizatorin përkatës BF7700.", en: "Professional matte clear coat with a uniform soft-matte finish, supplied with the corresponding BF7700 hardener." },
    description: {
      sq: "Llak transparent mat për automjete, i krijuar për një përfundim të njëtrajtshëm, të butë dhe mat. Ofron kontroll të qëndrueshëm të shkëlqimit, rezistencë ndaj gërvishtjeve, konsumimit dhe kimikateve. I përshtatshëm për lyerje të plota mat, panele individuale dhe riparime lokale. Përdoret me katalizator BF7700. \nKODI: BF8600Q.",
      en: "Automotive matte clear coat designed to deliver a smooth and uniform soft-matte finish with consistent gloss control. Provides good scratch, abrasion and chemical resistance. Suitable for full matte refinishing, individual panels and spot repairs. Used with BF7700 Hardner. \nCODE: BF8600Q.",
    },
    specs: [

    ],
    image: "2-59c41e8d",
    datasheet: "2-f680b0b1",
  },
  {
    id: 3,
    slug: "highest-grade-clearcoat",
    sku: "BF8001",
    name: { sq: "RIFINID Llak Highest-Grade", en: "RIFINID Highest-Grade Clear Coat" },
    category: "llaqe",
    brand: "RIFINID",
    variants: [
      { id: 28, label: { sq: "1 L + 0.5 L", en: "1 L + 0.5 L" }, option: { sq: "Standart", en: "Standard" }, packQty: 12 },
      { id: 53, label: { sq: "1 L + 0.5 L", en: "1 L + 0.5 L" }, option: { sq: "I shpejte", en: "Fast" } },
    ],
    optionName: { sq: "Katalit", en: "Hardner" },
    tag: "",
    short: { sq: "Llak Highest-Grade, llak premium me shkëlqim shumë të lartë, efekt të thellë pasqyrë dhe rezistencë të lartë ndaj gërvishtjeve dhe zverdhjes.", en: "Highest-Grade Clear Coat, premium clear coat with ultra-high gloss, deep mirror effect and excellent resistance to scratches and yellowing." },
    description: {
      sq: "Llak transparent premium me përqendrim shumë të lartë, i zhvilluar për rifinitura të nivelit të lartë. Jep një shtresë të plotë dhe kristalore me shkëlqim të thellë pasqyrë, rezistencë shumë të lartë ndaj gërvishtjeve dhe qëndrueshmëri afatgjatë ndaj zverdhjes. Ideal për automjete premium, lyerje të plota dhe riparime panelesh me kërkesa të larta për përfundimin. Përdoret me katalizator BF7715A Standard ose BF7715C Fast. \nKODI: BF8001.",
      en: "Premium ultra-high-concentration acrylic polyurethane clear coat developed for high-end automotive refinishing. Produces a full crystal-clear film with deep mirror gloss, excellent scratch resistance and long-term anti-yellowing performance. Ideal for premium vehicles, full resprays and high-quality panel repairs. Used with BF7715A Standard or BF7715C Fast Hardener. \nCODE: BF8001.",
    },
    specs: [

    ],
    image: "3-6b36d254",
    datasheet: "3-1863c1f7",
  },
  {
    id: 4,
    slug: "super-fast-repair-clear-coat",
    sku: "BF8830",
    name: { sq: "RIFINID Llak Super Fast", en: "RIFINID Super-Fast Repair Clear Coat" },
    category: "llaqe",
    brand: "RIFINID",
    variants: [
      { id: 29, label: { sq: "1 L + 0.5 L", en: "1 L + 0.5 L" }, option: { sq: "Shume i shpejte", en: "Super fast" }, packQty: 12 },
    ],
    optionName: { sq: "Katalit", en: "Hardener" },
    tag: "",
    short: { sq: "Llak HS me tharje shumë të shpejtë, ideal për riparime të shpejta, spot repair dhe panele individuale.", en: "Fast-curing HS clear coat, ideal for express repairs, spot repairs and single-panel refinishing." },
    description: {
      sq: "Llak transparent HS me tharje shumë të shpejtë, i zhvilluar posaçërisht për riparime ekspres dhe panele individuale. Formula me forcim të shpejtë redukton kohën e pritjes dhe pjekjes, duke ofruar shkëlqim të mirë, rezistencë ndaj gërvishtjeve dhe lustrim të lehtë. Ideal për spot repair dhe riparime të shpejta karrocerie. Përdoret me katalizatorin përkatës BF7760.\nKODI: BF8830.",
      en: "HS high-solid super-fast curing clear coat developed for express spot repairs and single-panel refinishing. Its rapid curing formula significantly reduces waiting and baking time while providing good gloss, scratch resistance and easy polishing. Ideal for quick body repairs and fast refinishing work. Used with the corresponding. CODE: BF7760 Hardener.BF8830.",
    },
    specs: [

    ],
    image: "4-67e2c28f",
    datasheet: "4-cbe45991",
  },
  {
    id: 5,
    slug: "ms-hardener-standard",
    sku: "BF7600-A",
    name: { sq: "RIFINID Katalit MS standart", en: "RIFINID MS Hardener Standard" },
    category: "hollues",
    brand: "RIFINID",
    variants: [
      { id: 31, label: { sq: "1 L", en: "1 L" }, packQty: 12 },
    ],
    tag: "",
    short: { sq: "Katalizator MS me tharje standarde për llaqe dhe sisteme 2K, i përshtatshëm për përdorim në temperatura normale pune.", en: "Standard-drying MS hardener for compatible clear coats and 2K systems, suitable for use at normal workshop temperatures." },
    description: {
      sq: "Katalit MS me tharje standarde për sistemet 2K. Projektuar për aplikime dhe riparime të përgjithshme në temperatura normale pune. Ofron forcim të kontrolluar dhe përfundim të qëndrueshëm. KODI: BF7600-A.",
      en: "Medium-solid standard-drying hardener for compatible 2K systems and clear coats. Designed for general repairs and refinishing under normal workshop temperatures, providing controlled curing and consistent finish quality. CODE: BF7600-A.",
    },
    specs: [

    ],
    image: "5-0a9ffcc5",
  },
  {
    id: 6,
    slug: "ms-hardener-fast",
    sku: "BF7600-C",
    name: { sq: "RIFINID Katalit MS i shpejtë", en: "MS Hardener Fast" },
    category: "hollues",
    brand: "RIFINID",
    variants: [
      { id: 33, label: { sq: "1 L", en: "1 L" }, packQty: 12 },
    ],
    tag: "",
    short: { sq: "Katalizator MS me tharje të shpejtë për llaqe dhe sisteme 2K, ideal për riparime të shpejta dhe temperatura më të ulëta.", en: "Fast-drying MS hardener for compatible clear coats and 2K systems, ideal for faster repairs and lower-temperature applications." },
    description: {
      sq: "Katalit MS me tharje të shpejtë për sistemet 2K. I përshtatshëm për riparime lokale dhe aplikime në temperatura më të ulëta, kur kërkohet reduktim i kohës së tharjes.",
      en: "Medium-solid fast-drying hardener for compatible 2K systems and clear coats. Suitable for spot repairs and lower-temperature applications where faster curing is required.",
    },
    specs: [

    ],
    image: "6-17dca678",
  },
  {
    id: 11,
    slug: "thinner-standard",
    sku: "M80-1",
    name: { sq: "Hollues/Dylen boje standart", en: "Thinner (Standard)" },
    category: "hollues",
    brand: "RIFINID",
    variants: [
      { id: 38, label: { sq: "1 L", en: "1 L" }, packQty: 12 },
      { id: 39, label: { sq: "5 L", en: "5 L" }, packQty: 4 },
    ],
    tag: "",
    short: { sq: "Hollues profesional boje standard për rregullimin e viskozitetit dhe përmirësimin e nivelimit gjatë aplikimit të bojës, llakut dhe primerit.", en: "Professional standard thinner for adjusting viscosity and improving flow and levelling during the application of paint, clear coat and primer." },
    description: {
      sq: "Hollues cilësor me avullim standard, i projektuar për të ulur viskozitetin e produktit dhe për të përmirësuar nivelimin dhe butësinë e shtresës së bojës. I përshtatshëm për përdorim profesional me sistemet kompatibile të primerit, bazës dhe bojës finale.",
      en: "High-quality standard thinner designed to reduce application viscosity and improve paint-film smoothness and levelling. Suitable for professional use with compatible primer, basecoat and topcoat systems.",
    },
    specs: [

    ],
    image: "11-5fb4e228",
  },
  {
    id: 12,
    slug: "primer-1k-rifinid",
    sku: "BF9950",
    name: { sq: "RIFINID Astar 1K", en: "RIFINID 1K Primer" },
    category: "astar",
    brand: "RIFINID",
    variants: [
      { id: 40, label: { sq: "1 L", en: "1 L" }, option: { sq: "E bardhe", en: "White" }, sku: "BF9950", packQty: 12 },
      { id: 54, label: { sq: "1 L", en: "1 L" }, option: { sq: "Gri", en: "Grey" }, sku: "BF9951" },
    ],
    optionName: { sq: "Ngjyra", en: "Color" },
    tag: "",
    short: { sq: "Astar 1K me tharje të shpejtë, fuqi të mirë mbushëse dhe smerilim të lehtë për përgatitjen e sipërfaqes para lyerjes.", en: "Fast-drying 1K primer with good filling power and easy sanding for surface preparation before painting." },
    description: {
      sq: "Primer surfacer 1K me tharje të shpejtë, për mbulimin e defekteve të vogla mbi stuko ose shtresa ekzistuese. Ka fuqi të mirë mbushëse, aplikohet lehtë dhe smerilohet shpejt për përgatitjen e sipërfaqes para lyerjes.",
      en: "Fast-drying 1K primer surfacer for covering minor defects over putty or existing finishes. Offers good filling power, easy application and easy sanding for efficient surface preparation before painting.",
    },
    specs: [

    ],
    image: "12-5bbb512b",
    datasheet: "12-cae84ca9",
  },
  {
    id: 14,
    slug: "degreaser",
    sku: "BF5581",
    name: { sq: "RIFINID Antisilikon", en: "RIFINID Degreaser / Anti-Silicone" },
    category: "hollues",
    brand: "RIFINID",
    variants: [
      { id: 42, label: { sq: "1 L", en: "1 L" }, packQty: 12 },
    ],
    tag: "",
    short: { sq: "Antisilikon profesional për heqjen e yndyrës, vajit, silikonit dhe papastërtive nga sipërfaqja para lyerjes.", en: "Professional degreaser for removing grease, oil, silicone and surface contaminants before painting." },
    description: {
      sq: "Degresant profesional, gati për përdorim, për largimin e yndyrës, vajit dhe ndotësve të tjerë nga sipërfaqja përpara lyerjes. Ndihmon në parandalimin e defekteve të bojës dhe mund të përdoret mbi bojë ekzistuese, primer, stuko dhe metal.",
      en: "Ready-to-use professional degreaser for removing grease, oil and other surface contaminants before painting. Helps prevent paint-film defects and is suitable for existing finishes, primer, putty and metal surfaces.",
    },
    specs: [

    ],
    image: "14-45e25d12",
    datasheet: "14-8bdeb2fc",
  },
  {
    id: 15,
    slug: "rifinid-astar-2k",
    sku: "BF9920",
    name: { sq: "RIFINID Astar 2K", en: "RIFINID 2K Quick-Dry Primer" },
    category: "astar",
    brand: "RIFINID",
    variants: [
      { id: 43, label: { sq: "1 L + 0.25 Katalit", en: "1 L + 0.25 Hardener" }, option: { sq: "Gri", en: "Grey" }, sku: "BF9920", packQty: 12 },
      { id: 55, label: { sq: "1 L + 0.25 Katalit", en: "1 L + 0.25 Hardener" }, option: { sq: "E bardhe", en: "White" }, sku: "BF9921" },
    ],
    optionName: { sq: "Ngjyra", en: "Color" },
    tag: "",
    short: { sq: "Primer 2K me tharje të shpejtë dhe fuqi të lartë mbushëse, i kompletuar me katalizatorin BF7750. Ofron aderencë të mirë, nivelim të lehtë dhe smerilim të thjeshtë para aplikimit të bojës.", en: "Quick-drying 2K primer with strong filling power, supplied with BF7750 hardener. Provides good adhesion, easy levelling and easy sanding before topcoat application." },
    description: {
      sq: "Primer surfacer 2K me tharje të shpejtë, i projektuar për rifiniturë profesionale automobilistike. Ka fuqi të lartë mbushëse, aderencë të mirë mbi stuko, filler dhe bojë të fortësuar të smeriluar, si dhe fleksibilitet dhe rezistencë të mirë ndaj goditjeve. Nivelohet dhe smerilohet lehtë, duke krijuar një bazë të qëndrueshme për shtresat përfundimtare pa absorbuar shkëlqimin e bojës. Vjen së bashku me katalizatorin përkatës BF7750.",
      en: "Quick-drying 2K primer surfacer designed for professional automotive refinishing. It offers strong filling power, good adhesion to putties, fillers and properly sanded hardened finishes, together with good flexibility and impact resistance. Easy to apply, level and sand, creating a stable base for subsequent coatings without absorbing the gloss of the topcoat. Supplied with the corresponding BF7750 hardener.",
    },
    specs: [
      spec("Lloji", "Type", "Primer Surfacer 2K", "2K Primer Surfacer"),
      spec("Tharja", "Drying", "E shpejtë", "Quick Dry"),
    ],
    image: "15-99986bdf",
    datasheet: "15-1b55740a",
  },
  {
    id: 18,
    slug: "astar-1k-plastik",
    sku: "BF9960",
    name: { sq: "RIFINID Astar Plastik 1K", en: "RIFINID 1K Plastic Primer" },
    category: "astar",
    brand: "RIFINID",
    variants: [
      { id: 46, label: { sq: "1 L", en: "1 L" }, packQty: 12 },
    ],
    tag: "",
    short: { sq: "Astar transparent 1K për plastikë, i gatshëm për përdorim dhe i projektuar për të përmirësuar aderencën e bojës mbi pjesët plastike.", en: "Ready-to-use transparent 1K plastic primer designed to improve paint adhesion on plastic automotive parts." },
    description: {
      sq: "Astar plastik transparent 1K me tharje të shpejtë, i projektuar për të rritur aderencën e sistemit të bojës mbi pjesët plastike të automjeteve. Është gati për përdorim dhe ofron aderencë të mirë në një gamë të gjerë sipërfaqesh plastike.",
      en: "Fast-drying transparent 1K plastic primer designed to promote paint-system adhesion on automotive plastic parts. Ready to use and provides good adhesion to a wide range of plastic surfaces used in vehicle manufacturing.",
    },
    specs: [

    ],
    image: "18-df7abd55",
    datasheet: "18-cd5257a4",
  },
  {
    id: 19,
    slug: "stuko-multi-m-01",
    sku: "M-01",
    name: { sq: "RIFINID Stuko Multi", en: "RIFINID Multi Putty" },
    category: "stuko",
    brand: "RIFINID",
    variants: [
      { id: 47, label: { sq: "1 L", en: "1 L" }, packQty: 12 },
      { id: 51, label: { sq: "2 L", en: "2 L" }, sku: "M-02", packQty: 6 },
    ],
    tag: "",
    short: { sq: "Stuko multifunksionale për mbushjen dhe nivelimin e defekteve, me aderencë të mirë dhe smerilim të lehtë.", en: "Multi-purpose body filler for filling and levelling bodywork imperfections, with good adhesion and easy sanding." },
    description: {
      sq: "Stuko poliester multifunksionale me aftësi të mirë mbushëse dhe aderencë të fortë, e përshtatshme për korrigjimin e parregullsive dhe defekteve të sipërfaqes gjatë riparimit të karrocerisë. Përpunohet dhe smerilohet lehtë për të krijuar një sipërfaqe të lëmuar para astarit.",
      en: "Multi-purpose polyester body filler with good filling ability and strong adhesion, suitable for correcting surface irregularities and defects during body repair. Easy to shape and sand to produce a smooth surface before primer application.",
    },
    specs: [

    ],
    image: "19-f4d9ddaf",
    datasheet: "19-0d151154",
  },
  {
    id: 21,
    slug: "fiber-putty-rifinid",
    sku: "M-05",
    name: { sq: "RIFINID Stuko Fibër", en: "RIFINID Fiber Putty" },
    category: "stuko",
    brand: "RIFINID",
    variants: [
      { id: 49, label: { sq: "2 L", en: "2 L" }, packQty: 6 },
    ],
    tag: "",
    short: { sq: "Stuko e përforcuar me fibra për mbushjen e defekteve, çarjeve dhe dëmtimeve më të mëdha, me fortësi dhe aderencë të lartë.", en: "Fiber-reinforced body filler for larger defects, cracks and damaged areas, offering high strength and strong adhesion." },
    description: {
      sq: "Stuko me fibra, e projektuar për mbushjen dhe lidhjen e defekteve më të mëdha, çarjeve dhe dëmtimeve të sipërfaqes. Ofron forcim të shpejtë, fortësi të lartë, aderencë të fortë dhe rezistencë të mirë ndaj ujit pas forcimit. E përshtatshme për metal, alumin, sipërfaqe të galvanizuara, FRP dhe sipërfaqe të tjera.",
      en: "Fiber-reinforced polyester body filler designed for bridging and filling larger defects, dents and cracks. Provides fast curing, high hardness, strong adhesion and good water resistance after curing. Suitable for metal, aluminium, galvanized surfaces, FRP and other compatible substrates.",
    },
    specs: [

    ],
    image: "21-eebf181c",
    datasheet: "21-ccef8130",
  },
  {
    id: 22,
    slug: "light-putty-rifinid",
    sku: "M-06",
    name: { sq: "RIFINID Stuko Light", en: "RIFINID Lightweight Putty" },
    category: "stuko",
    brand: "RIFINID",
    variants: [
      { id: 50, label: { sq: "0.7 L", en: "0.7 L" }, packQty: 12 },
    ],
    tag: "",
    short: { sq: "Stuko e lehtë për mbushje dhe nivelim të sipërfaqeve, e lehtë për t’u aplikuar, formuar dhe smeriluar.", en: "Lightweight body filler for filling and levelling surfaces, easy to apply, shape and sand." },
    description: {
      sq: "Stuko e lehtë, e projektuar për mbushjen dhe nivelimin e defekteve të sipërfaqes duke ofruar aplikim dhe përpunim të lehtë. E përshtatshme për riparime ku kërkohet mbushje efikase dhe një sipërfaqe e lëmuar për fazat pasuese të rifiniturës.",
      en: "Lightweight body filler designed for filling and levelling surface defects while providing easy application and finishing. Suitable for automotive repairs where efficient filling and a smooth surface are required before subsequent refinishing stages.",
    },
    specs: [

    ],
    image: "22-a1f0f45c",
    datasheet: "22-0bcfc54d",
  },
  {
    id: 23,
    slug: "kraft-masking-paper",
    sku: "730/85/LEN",
    name: { sq: "Letër Kraft për Mbulim", en: "Kraft Masking Paper" },
    category: "masking",
    brand: "3A Color",
    variants: [
      { id: 56, label: { sq: "85cm X 200m", en: "85cm X 200m" } },
    ],
    tag: "",
    short: { sq: "Letër kraft profesionale për maskimin dhe mbrojtjen e sipërfaqeve gjatë lyerjes së automjeteve. E përshtatshme për përdorim me tenije dhe për mbrojtje ndaj bojës dhe overspray-t.", en: "Professional kraft masking paper for protecting vehicle surfaces during automotive painting and refinishing. Suitable for use with masking tape and for protection against paint and overspray." },
    description: {
      sq: "Letër kraft profesionale për maskimin dhe mbrojtjen e sipërfaqeve gjatë lyerjes së automjeteve. Përdoret për të mbuluar zonat që nuk duhet të ekspozohen ndaj bojës, primerit ose overspray-t. Letra është e trajtuar me WS Treatment, që ndihmon në rritjen e rezistencës ndaj lagështisë dhe depërtimit të materialeve gjatë punës. Përshtatet lehtë me format e automjetit dhe përdoret së bashku me tenije për një mbulim të pastër, të sigurt dhe profesional. Përmasa: 85 cm x 200 m.",
      en: "Professional kraft masking paper for protecting vehicle surfaces during automotive painting and refinishing. It is used to cover areas that should not be exposed to paint, primer or overspray. The paper features WS Treatment, helping improve resistance to moisture and material penetration during application. It adapts easily to vehicle contours and is designed for use with masking tape to provide clean, secure and professional protection.\nSize: 85 cm x 200 m.",
    },
    specs: [
      spec("Materiali", "Material", "Letër Kraft", "Kraft Paper"),
      spec("Përdorimi", "Application", "Mbrojtës automotiv", "Automotive Masking"),
      spec("Përmasa", "Size", "85cm X 200m", "85cm X 200m"),
      spec("Formati", "Format", "Rul", "Roll"),
    ],
    image: "23-c298d46b",
  },
  {
    id: 24,
    slug: "masking-film",
    sku: "779/4.6N",
    name: { sq: "Film Mbrojtes Elektrostatik", en: "Electrostatic Masking Film" },
    category: "masking",
    brand: "3A Color",
    variants: [
      { id: 57, label: { sq: "4.60m x 120m", en: "4.60m x 120m" } },
    ],
    tag: "4.60m x 120m",
    short: { sq: "Film maskues elektrostatik profesional për mbrojtjen e automjeteve gjatë lyerjes dhe rifiniturës. Ngjitet lehtë mbi sipërfaqe dhe mbron nga boja, primeri, pluhuri dhe overspray.", en: "Professional electrostatic masking film for vehicle protection during painting and refinishing. Clings easily to surfaces and protects against paint, primer, dust and overspray." },
    description: {
      sq: "Plasmas mbrojtës elektrostatik profesional për mbrojtjen e automjeteve gjatë lyerjes dhe punimeve të rifiniturës. Falë efektit elektrostatik, filmi ngjitet lehtë pas sipërfaqes së automjetit dhe qëndron në pozicion gjatë aplikimit. Ndihmon në mbrojtjen e zonave që nuk duhen ekspozuar ndaj bojës, primerit, pluhurit dhe overspray-t. Me trashësi 8 mikron, ofron mbulim të lehtë, praktik dhe efikas për punime profesionale body shop. Përmasa: 4.60 m x 120 m\nTrashësia: 8 micron",
      en: "Professional electrostatic masking film designed to protect vehicles during painting and refinishing work. Thanks to its electrostatic effect, the film clings easily to the vehicle surface and stays in position during application. It helps protect areas that should not be exposed to paint, primer, dust or overspray. With a thickness of 8 micron, it provides lightweight, practical and efficient coverage for professional body shop use. Size: 4.60 m x 120 m\nThickness: 8 micron",
    },
    specs: [
      spec("Përdorimi", "Application", "Mbrojtës automotiv", "Automotive Masking"),
      spec("Përmasa", "Size", "4.60m x 120m", "4.60m x 120m"),
      spec("Trashësia", "Thickness", "8 mikron", "8 micron"),
      spec("Formati", "Format", "Rul", "Roll"),
    ],
    image: "24-66c69f9e",
  },
  {
    id: 25,
    slug: "pasta-abrasive",
    sku: "1350N",
    name: { sq: "Pastë Abrasive K70", en: "Coarse Grained Abrasive Paste" },
    category: "polish",
    brand: "3A Color",
    variants: [
      { id: 58, label: { sq: "500ml", en: "500ml" }, packQty: 6 },
    ],
    tag: "",
    short: { sq: "Pastë abrasive me bazë uji për lustrimin e sipërfaqeve të lyera, me veprim më të fortë abraziv për fazat e para të korrigjimit.", en: "Water-based abrasive paste for polishing painted surfaces, with stronger cutting action for the initial correction stages." },
    description: {
      sq: "Pastë abrasive me kokërr të trashë, me bazë uji, e projektuar për lustrimin e sipërfaqeve të lyera. E përshtatshme për fazat e para të lustrimit ku kërkohet veprim abraziv më i fortë mbi sipërfaqen e bojës.",
      en: "Water-based coarse grained abrasive paste designed for polishing painted surfaces. Suitable for the initial polishing stages where a stronger abrasive action is required on the paint surface.",
    },
    specs: [
      spec("Lloji", "Type", "Pastë abrasive me kokërr të trashë", "Coarse Grained Abrasive Paste"),
      spec("Baza", "Base", "Ujë", "Water Based"),
      spec("Kapaciteti", "Volume", "500 ml", "500 ml"),
    ],
    image: "25-1c27c747",
  },
  {
    id: 26,
    slug: "fine-abrasive-paste",
    sku: "1360N",
    name: { sq: "Pastë Abrasive Fine K40", en: "Fine Abrasive Paste K40" },
    category: "polish",
    brand: "3A Color",
    variants: [
      { id: 59, label: { sq: "500ml", en: "500ml" }, packQty: 6 },
    ],
    tag: "",
    short: { sq: "Pastë abrasive fine me bazë uji për lustrimin dhe përfundimin e sipërfaqeve të lyera, duke ndihmuar në arritjen e një finish-i më të pastër.", en: "Water-based fine abrasive paste for polishing and finishing painted surfaces, helping achieve a cleaner final finish." },
    description: {
      sq: "Pastë abrasive fine me bazë uji, e projektuar për lustrimin e sipërfaqeve të lyera. Ofron një veprim abraziv më të imët dhe është e përshtatshme për fazat e përfundimit të procesit të lustrimit.",
      en: "Water-based fine abrasive paste designed for polishing painted surfaces. Provides a finer abrasive action and is suitable for the finishing stages of the polishing process.",
    },
    specs: [
      spec("Lloji", "Type", "Pastë abrasive fine", "Fine Abrasive Paste"),
      spec("Baza", "Base", "Ujë", "Water Based"),
      spec("Kapaciteti", "Volume", "500ml", "500ml"),
    ],
    image: "26-db71aa19",
  },
  {
    id: 27,
    slug: "micro-abrasive-polish",
    sku: "1370N",
    name: { sq: "Polish Mikro-Abrasiv", en: "Micro-Abrasive Polish" },
    category: "polish",
    brand: "3A Color",
    variants: [
      { id: 60, label: { sq: "500ml", en: "500ml" }, packQty: 6 },
    ],
    tag: "",
    short: { sq: "Polish me bazë uji, që ndihmon në reduktimin e mikrogërvishtjeve dhe zverdhjes, duke rikthyer shkëlqimin.", en: "Water-based polish for plastic and plexiglass that helps reduce micro-scratches and yellowing while restoring shine." },
    description: {
      sq: "Polish mikro-abrasiv me bazë uji e cila ndihmon në eliminimin e mikrogërvishtjeve dhe zverdhjes së sipërfaqes, duke rikthyer shkëlqimin origjinal.",
      en: "Water-based micro-abrasive polish for polishing plastic and plexiglass surfaces. Helps remove micro-scratches and yellowing while restoring the original shine of the surface.",
    },
    specs: [
      spec("Lloji", "Type", "Polish mikro-abrasiv", "Micro-Abrasive Polish"),
      spec("Baza", "Base", "Ujë", "Water Based"),
      spec("Kapaciteti", "Volume", "500ml", "500ml"),
    ],
    image: "27-4c0bab07",
  },
  {
    id: 28,
    slug: "foam-masking-tape",
    sku: "1410N",
    name: { sq: "Kordon për Izolimin e Dyerve", en: "Foam Masking Tape" },
    category: "masking",
    brand: "3A Color",
    variants: [
      { id: 61, label: { sq: "13 mm x 50 m", en: "13 mm x 50 m" } },
    ],
    tag: "",
    short: { sq: "Shirit shkumë vetëngjitës për maskim dhe izolim gjatë lyerjes së automjeteve. I përshtatshëm për zona si hapësirat e dyerve dhe bashkimet e paneleve.", en: "Self-adhesive foam tape for masking and sealing during automotive painting. Suitable for areas such as door gaps and panel joints." },
    description: {
      sq: "Shirit profesional prej shkume vetëngjitëse, i projektuar për maskimin dhe izolimin e hapësirave gjatë proceseve të lyerjes dhe rifiniturës së automjeteve. Ndihmon në krijimin e një kufiri të kontrolluar të bojës dhe redukton depërtimin e overspray-t në zona të vështira për t’u izoluar. I përshtatshëm për përdorim në hapësirat e dyerve, kapakëve dhe bashkimeve të paneleve.",
      en: "Professional self-adhesive foam tape designed for masking and sealing gaps during automotive painting and refinishing. Helps create a controlled paint edge and reduces overspray penetration in difficult-to-mask areas. Suitable for door gaps, panel joints and similar bodywork openings.",
    },
    specs: [

    ],
    image: "28-0106fca0",
  },
  {
    id: 29,
    slug: "tack-cloth",
    sku: "1430N",
    name: { sq: "Pecetë dylli", en: "Tack Cloth" },
    category: "masking",
    brand: "3A Color",
    variants: [
      { id: 62, label: { sq: "38 x 45cm", en: "38 x 45cm" } },
    ],
    tag: "Model i ri",
    short: { sq: "Pecetë profesionale për kapjen e pluhurit para lyerjes, model i ri me teknologji të përmirësuar. Ndryshe nga modelet tradicionale me rrudha, nuk lë push në sipërfaqe.", en: "Professional tack cloth for dust removal before painting, featuring new-generation technology. Unlike traditional crinkled tack cloths, it does not leave lint on the surface." },
    description: {
      sq: "Pecetë profesionale për kapjen dhe largimin e pluhurit nga sipërfaqet përpara aplikimit të bojës, primerit ose llakut. Ky është një model i ri me teknologji të përmirësuar për kapjen e pluhurit, pa strukturën tradicionale me rrudha. Modelet klasike me rrudha mund të lënë push gjatë përdorimit, ndërsa ky version është projektuar për të siguruar një sipërfaqe më të pastër para lyerjes. E përshtatshme për përdorim me produkte me bazë uji dhe solventi.",
      en: "Professional tack cloth designed to capture and remove dust before the application of paint, primer or clear coat. This is a new-generation model with improved dust-capturing technology, without the traditional crinkled structure. Conventional crinkled tack cloths may leave lint during use, while this version is designed to provide a cleaner surface before painting. Suitable for both water-based and solvent-based products.",
    },
    specs: [
      spec("Modeli", "Model", "Gjeneratë e re", "New Generation"),
      spec("Teknologjia", "Technology", "Sistem i përmirësuar për kapjen e pluhurit", "Improved dust-capturing system"),
      spec("Ngjyra", "Color", "Blu", "Blue"),
      spec("Përmasa", "Size", "38 x 45 cm", "38 x 45 cm"),
    ],
    image: "29-1d6ddd35",
  },
  {
    id: 30,
    slug: "plastic-mixing-cup-with-lid-set",
    sku: "1610/375N",
    name: { sq: "Set Gotë Matëse Plastike me Kapak", en: "Graduated Plastic Mixing Cup with Lid Set" },
    category: "aditive-ndihmese",
    brand: "3A Color",
    variants: [
      { id: 63, label: { sq: "375 ml", en: "375 ml" } },
      { id: 64, label: { sq: "750 ml", en: "750 ml" }, sku: "1610/750N" },
      { id: 65, label: { sq: "1100 ml", en: "1100 ml" }, sku: "1610/1100N" },
      { id: 66, label: { sq: "1550 ml", en: "1550 ml" }, sku: "1610/1550N" },
      { id: 67, label: { sq: "2500 ml", en: "2500 ml" }, sku: "1610/2500N" },
    ],
    tag: "",
    short: { sq: "Set profesional me gotë matëse plastike transparente dhe kapak për përzierjen, matjen dhe ruajtjen e përkohshme të bojrave, primerëve, llaqeve dhe materialeve të tjera të rifiniturës.", en: "Professional set including a transparent graduated plastic mixing cup and matching lid, designed for measuring, mixing and temporary storage of paints, primers, clear coats and other refinishing materials." },
    description: {
      sq: "Set i përbërë nga gotë matëse plastike transparente dhe kapaku përkatës, i projektuar për përdorim profesional në përzierjen e bojrave dhe materialeve të rifiniturës. Gotat janë prej plastike me trashësi të lartë dhe kanë gradacion të realizuar me teknologji lazer, për lexim të qartë dhe matje praktike gjatë përzierjes. Kapaku përshtatet me madhësinë përkatëse të gotës dhe ndihmon në mbrojtjen e përmbajtjes gjatë përdorimit ose ruajtjes së përkohshme. Produkt Made in Italy.",
      en: "Set consisting of a transparent graduated plastic mixing cup and matching lid, designed for professional use when mixing paints and refinishing materials. The cups are made from high-thickness plastic and feature laser-engraved graduations for clear reading and practical measurement during mixing. Each lid matches the corresponding cup size and helps protect the contents during use or temporary storage. Made in Italy.",
    },
    specs: [
      spec("Lloji", "Type", "Set gotë matëse + kapak", "Mixing cup + lid set"),
      spec("Gradacioni", "Graduation", "Laser", "Laser"),
      spec("Origjina", "Origin", "Made in Italy", "Made in Italy"),
    ],
    image: "30-af6bb8d5",
  },
  {
    id: 31,
    slug: "paint-strainer",
    sku: "PS-1519",
    name: { sq: "Filtër për Bojë 190 Micron", en: "Paint Strainer 190 Micron" },
    category: "aditive-ndihmese",
    brand: "3A Color",
    variants: [
      { id: 68, label: { sq: "150 g / 190 micron", en: "150 g / 190 micron" } },
    ],
    tag: "",
    short: { sq: "Filtër profesional prej letre për filtrimin e bojës dhe materialeve të rifiniturës përpara aplikimit me pistoletë. Ndihmon në largimin e papastërtive dhe grimcave që mund të ndikojnë në përfundimin e bojës.", en: "Professional paper paint strainer for filtering paint and refinishing materials before spray application. Helps remove impurities and particles that may affect the final finish." },
    description: {
      sq: "Filtër konik për bojë, i projektuar për përdorim në punimet profesionale të rifiniturës automobilistike. Me filtër 190 micron, ndihmon në kapjen e grimcave, papastërtive dhe materialeve të patretura përpara hedhjes së bojës në pistoletë. Përdorimi i filtrit ndihmon në reduktimin e bllokimeve të pistoletës dhe në arritjen e një aplikimi më të pastër dhe uniform.",
      en: "Conical paint strainer designed for professional automotive refinishing applications. With a 190 micron mesh, it helps capture particles, impurities and undissolved material before paint is poured into the spray gun. Using a paint strainer helps reduce spray gun blockages and supports a cleaner, more uniform application.",
    },
    specs: [
      spec("Materiali", "Material", "Letër", "Paper"),
      spec("Mesh", "Mesh", "190 micron", "190 micron"),
      spec("Pesha", "Weight", "150 g", "150 g"),
    ],
    image: "31-b99deb57",
  },
  {
    id: 32,
    slug: "masking-tape",
    sku: "ZY-111",
    name: { sq: "Tenije Izolimi", en: "Automotive Masking Tape" },
    category: "masking",
    brand: "3A Color",
    variants: [
      { id: 69, label: { sq: "50 m", en: "50 m" }, option: { sq: "18 mm", en: "18 mm" }, sku: "ZY-111/18" },
      { id: 70, label: { sq: "50 m", en: "50 m" }, option: { sq: "36 mm", en: "36 mm" }, sku: "ZY-111/36" },
      { id: 71, label: { sq: "50 m", en: "50 m" }, option: { sq: "48 mm", en: "48 mm" }, sku: "ZY-111/48" },
    ],
    optionName: { sq: "Gjerësia", en: "Width" },
    tag: "",
    short: { sq: "Tenije izolimi profesional për lyerje dhe rifiniturë automobilistike, rezistent ndaj temperaturave deri në 80°C. I përshtatshëm për mbrojtjen e zonave gjatë aplikimit të bojës, primerit ose llakut.", en: "Professional automotive masking tape resistant to temperatures up to 80°C. Suitable for protecting areas during the application of paint, primer or clear coat." },
    description: {
      sq: "Shirit maskues i projektuar për përdorim profesional në lyerjen dhe rifiniturën e automjeteve. Përdoret për të mbuluar dhe kufizuar zonat që nuk duhet të ekspozohen ndaj bojës, primerit, llakut ose overspray-t. Reziston ndaj temperaturave deri në 80°C, duke e bërë të përshtatshëm edhe për procese tharjeje dhe pune në temperatura të ngritura. Mund të përdoret së bashku me letër ose film maskues.",
      en: "Masking tape designed for professional automotive painting and refinishing. Used to cover and define areas that should not be exposed to paint, primer, clear coat or overspray. Resistant to temperatures up to 80°C, making it suitable for drying processes and elevated-temperature applications. Can be used together with masking paper or masking film.",
    },
    specs: [
      spec("Temperatura", "Temperature Resistance", "80°C", "80°C"),
      spec("Gjatësia", "Length", "50 m", "50 m"),
      spec("Ngjyra", "Color", "E verdhë", "Yellow"),
    ],
    image: "32-3a9de4f9",
  },
  {
    id: 33,
    slug: "sponge-polishing-pad",
    sku: "PP-L",
    name: { sq: "Tampon Lustrimi", en: "Sponge Polishing Pad" },
    category: "polish",
    brand: "3A Color",
    variants: [
      { id: 72, label: { sq: "6 inch", en: "6 inch" } },
    ],
    tag: "",
    short: { sq: "Sfungjer profesional për lustrimin e sipërfaqeve të automjeteve, i përshtatshëm për përdorim me makinë lustruese me fileto M14.", en: "Professional sponge polishing pad for automotive surfaces, suitable for use with polishing machines featuring an M14 thread." },
    description: {
      sq: "Sfungjer lustrimi me diametër 6 inch, i projektuar për punime profesionale në karroceri dhe rifiniturë automobilistike. Përdoret për aplikimin dhe punimin e pastave lustruese dhe produkteve të polish-it, duke ndihmuar në përmirësimin e finish-it dhe shkëlqimit të sipërfaqes. Pajiset me lidhje M14 për montim direkt në makinë lustruese.",
      en: "6-inch sponge polishing pad designed for professional automotive bodywork and refinishing applications. Suitable for applying and working polishing compounds and polish products, helping improve surface finish and gloss. Features an M14 connection for direct mounting on a polishing machine.",
    },
    specs: [
      spec("Diametri", "Diameter", "6 inch", "6 inch"),
      spec("Lidhja", "Connection", "M14", "M14"),
    ],
    image: "33-2a2ef9c3",
  },
]

export let PRODUCT_BY_ID = new Map(PRODUCTS.map((p) => [p.id, p]))
export let PRODUCT_BY_SLUG = new Map(PRODUCTS.map((p) => [p.slug, p]))

export let BRANDS = [...new Set(PRODUCTS.map((p) => p.brand))].sort()

/**
 * Called once before the app mounts, so every module that imports these bindings
 * reads server data on its first render and no consumer needs to change.
 */
export function hydrateProducts(products: Product[]): void {
  PRODUCTS = products
  PRODUCT_BY_ID = new Map(products.map((p) => [p.id, p]))
  PRODUCT_BY_SLUG = new Map(products.map((p) => [p.slug, p]))
  BRANDS = [...new Set(products.map((p) => p.brand))].sort()
}
